var React = require('react');

function Imagecorner (props) {
    return React.createElement("svg",props,[React.createElement("metadata",{"key":0},React.createElement("rdf:RDF",null,React.createElement("cc:Work",{"rdfAbout":""},[React.createElement("dc:format",{"key":0},"image/svg+xml"),React.createElement("dc:type",{"rdfResource":"http://purl.org/dc/dcmitype/StillImage","key":1}),React.createElement("dc:title",{"key":2})]))),React.createElement("g",{"transform":"translate(-41.138 -233.51)","key":1},React.createElement("path",{"d":"m41.943 247.54h6.6146c3.5341 0 6.615-3.1333 6.615-6.6149v-6.6146","fill":"none","opacity":".969","style":{"paintOrder":"markers stroke fill"}}))]);
}

Imagecorner.defaultProps = {"width":"14.828mm","height":"14.828mm","version":"1.1","viewBox":"0 0 17 17","xmlnsCc":"http://creativecommons.org/ns#","xmlnsDc":"http://purl.org/dc/elements/1.1/","xmlnsRdf":"http://www.w3.org/1999/02/22-rdf-syntax-ns#"};

module.exports = Imagecorner;

Imagecorner.default = Imagecorner;
